import { IPreferredLanguage } from "../../../Orchestrator/Types/Index";



export class TopBarContext {

    public listOfLanguage: IPreferredLanguage[] = []
    public userName: string = "";
    constructor() {
    }
}